import { FormControlLabel, FormLabel, Radio } from "@mui/material";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormRadioGroup } from "../../../../../../components/fields";
import { ReactQueryKey, RentalType } from "../../../../../../types";
import { IFormValues } from "../../../../types";
import { useQueryClient } from "@tanstack/react-query";
import { useSetRecoilState } from "recoil";
import { IRangeDate } from "../../../../../../api/services";
import {editRangeDateValidity} from "../../../../recoil";

const FormRentalType = () => {

    const { t } = useTranslation('booking');

    const queryClient = useQueryClient();

    const setRangeDate = useSetRecoilState<IRangeDate | undefined>(editRangeDateValidity);

    const formContext = useFormContext<IFormValues>();

    /**
     * Change Radio
     */
    const handleChange = useCallback(() => {
        formContext.resetField('bookingOwner');
        formContext.resetField('invoice');
        formContext.resetField('basicDetails.pickupLocation');
        formContext.resetField('basicDetails.dropoffLocation');
        formContext.resetField('basicDetails.customerCode');
        formContext.resetField('basicDetails.carGroup');
        formContext.resetField('basicDetails.mileageIncluded');
        formContext.resetField('basicDetails.cig');

        queryClient.resetQueries([ReactQueryKey.Product, {
            segment: formContext.getValues('basicDetails.rentalType'),
            tenant: formContext.getValues('basicDetails.tenant') as string,
            dealer: formContext.getValues('basicDetails.dealer') as string
        }]);

        setRangeDate({startDate: null, endDate: null});
    }, []);

    return (
        <>
            <FormLabel>{t('label.rentalType')}</FormLabel>
            <FormRadioGroup<IFormValues>
                name="basicDetails.rentalType"
                onChange={handleChange}
            >
                <FormControlLabel
                    value={RentalType.RETAIL}
                    label={t('label.public')}
                    control={<Radio disabled={true}/>}
                />
                <FormControlLabel
                    value={RentalType.CORPORATE}
                    label={t('label.affiliated')}
                    control={<Radio disabled={true}/>}
                />
            </FormRadioGroup >
        </>
    );
}

export default FormRentalType;
